<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="specificComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="specificComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header h5 bg-transparent border-0">Product List</div>
          <div class="card-body">
              <v-client-table :data="specificData" :columns="tableColumns" :options="tableOptions">
                <div slot="prodSelect" slot-scope="props">
                  <a :href="productSinglePageURL + props.row.id" class=""><i class="fa fa-search" aria-hidden="true"></i></a>
                </div>
              </v-client-table>
          </div>
        </div>
      </div>
    </div>


</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/admin-user-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {

  data: function () {
    return { 
      productSinglePageURL: '/admin/product-single-main-page/',
      tableColumns: [ 'id','part_number', 'name', 'statusName', 'created_at', 'prodSelect'],
      tableOptions: {
        skin: 'table table-sm table-hover border-0 vuetable2',
        filterable: false,
        pagination: { chunk:4 },
        perPageValues: [],
        perPage: 15,
        dateColumns: ['created_at'],
        dateFormat: 'MM-DD-YYYY',
        toMomentFormat:  'YYYY-MM-DD H:mm:ss',
        texts:{
          filter:"",
          count:"",
          filterPlaceholder:"Search",
          page:"Page:",
          noResults:"No matching records",
          loading:'Loading...',
        },
        columnsClasses: {
          statusName: 'text-center',
          created_at: 'text-center',
        }, 
        headings: { 
          id: 'Ref',
          part_number: 'P/N',
          name: 'Name',
          statusName: 'Status',
          created_at: 'Start',
          prodSelect: '',
        },

      }
    }
  },
  computed: {
    specificData () { return this.$store.state.productList },
    specificComp () { return this.$store.state.productComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    detailView(x){
      var _this = this;
      _this.changeRightView('user-single', props.row.id, '')
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
